import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';

export const devGuardFn: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  if (state.url === '/styleguide' && !environment.production) return true;

  inject(Router).navigate(['/dashboard']);
  return false;
};
